import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function optionalDecimalValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
        const value = control.value;

        // Allow empty/null
        if (value === null || value === '' || value === undefined) {
            return null;
        }

        // Match a valid decimal number (positive/negative, optional decimal)
        const isValid = /^-?\d+(\.\d+)?$/.test(value);

        return isValid ? null : { invalidDecimal: true };
    };
}
